import FormVM from './form-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    const vm = new Vue(FormVM);
    vm.bindData(JSON.parse(node.dataset.campaignData));
    vm.$mount(node);
  }
};
